export interface BeforeInstallPromptUserChoice {
  readonly outcome: 'accepted' | 'dismissed';
}

interface BeforeInstallPromptEvent extends Event {
  readonly userChoice: Promise<BeforeInstallPromptUserChoice>;
  prompt(): void;
}

let deferredPrompt: Promise<BeforeInstallPromptEvent> | undefined;

export const initializeInstallPrompt = (): void => {
  deferredPrompt = new Promise((resolve) => {
    window.addEventListener('beforeinstallprompt', (evt: Event) => {
      evt.preventDefault();
      resolve(evt as BeforeInstallPromptEvent);
    });
  });
};

export const installPromptReady = async (): Promise<void> => {
  await deferredPrompt;
};

export const showInstallPrompt = async (): Promise<void> => {
  // istanbul ignore next
  if (deferredPrompt == null) {
    throw new Error('Event listener for "beforeinstallprompt" has not been added yet');
  }

  const prompt = await deferredPrompt;
  prompt.prompt();
  const { outcome } = await prompt.userChoice;

  if (outcome !== 'accepted') {
    throw new Error('Installation prompt was not accepted');
  }
};
